/**
 * Full-page host for the ComparisonAnalyticsView — Iter-127.
 * Opens at /admin/comparison-analytics. Deep-dive presentation-ready
 * view that lives on its own route (kept off the main Analytics tab
 * per owner request).
 */
import React from 'react';
import ComparisonAnalyticsView from '../components/admin/ComparisonAnalyticsView';

export default function ComparisonAnalyticsPage() {
  return (
    <div data-testid="comparison-analytics-page">
      <ComparisonAnalyticsView />
    </div>
  );
}
